import HelpTable from './HelpTable'

export default HelpTable
